import { useLazyQuery, useMutation } from '@apollo/client'
import {
  List,
  Modal,
  Paper,
  Slide,
  Typography,
  Button,
  CircularProgress,
  Grow
} from '@material-ui/core'
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat'
import React from 'react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { DateRangePicker } from '../../components/DatePicker/DateRangePicker'
import { CANCEL_POLICIES_QUERY } from '../../graphql/cancelPolicies'
import { RATEPLAN_ADD_POLICY_MUTATION } from '../../graphql/ratePlanPolicies'
import { DateObject } from '../../helpers/date'
import { lang, getTranslate, getDirection } from '../../localization'
import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import RatePlansAddPoliciesModalRow from './RatePlansAddPoliciesModalRow'
import useStyles from './styles/RatePlansAddPoliciesModal.styles'

interface RatePlansAddPoliciesModalProps {
  isOpen: boolean
  onClose: () => void
  providerCode: string
  refetch: () => void
}
const RatePlansAddPoliciesModal: React.FC<RatePlansAddPoliciesModalProps> = ({
  isOpen,
  onClose,
  providerCode,
  refetch
}) => {
  const classes = useStyles()
  const [dateObject, setdateObject] = useState<DateObject>({})
  const [selectedTemplate, setselectedTemplate] = useState<string>('')
  const params = useParams<{
    accommodationID: string
    ratePlanID: string
    roomTypeID: string
  }>()

  const [showItems, setshowItems] = useState<boolean>(false)
  const [timePickerSelected, setTimePickerSelected] = useState<boolean>(false)
  const [showDateAfterSelect, setshowDateAfterSelect] = useState<boolean>(false)

  const [addRatePlanPolicy, { loading: loadingForAddRatePlanPolicy }] =
    useMutation(RATEPLAN_ADD_POLICY_MUTATION, {
      onCompleted: (response) => {
        toast.success(response.addRatePlanPolicy.message)
        refetch()
        onClose()
      },
      onError: (err) => {
        toast.error(err.message)
        onClose()
      }
    })

  useEffect(() => {
    setshowItems(true)
  }, [])

  const [getPolicies, { data, loading }] = useLazyQuery<{
    cancelPolicies: CancelPolicy[]
  }>(CANCEL_POLICIES_QUERY, {
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if (providerCode)
      getPolicies({
        variables: {
          providerCode: providerCode
        }
      })
  }, [providerCode])

  const onAddPolicy = () => {
    addRatePlanPolicy({
      variables: {
        accID: params.accommodationID,
        roomTypeID: params.roomTypeID,
        providerCode: providerCode,
        ratePlanID: params.ratePlanID,
        // tenantID: tenantID,
        input: {
          from: dateObject.gregorianStartDate,
          to: dateObject.gregorianEndDate,
          PolicyId: selectedTemplate
        }
      }
    })
  }
  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide in={isOpen} direction="down">
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <Typography variant="h3">{getTranslate('Add Policies')}</Typography>
          </div>
          <div className={classes.datePickerInput}>
            <Button
              className={classes.buttonOfDate}
              variant="contained"
              onClick={() => {
                setTimePickerSelected(!timePickerSelected)
                setshowDateAfterSelect(!showDateAfterSelect)
              }}
              color="primary">
              <div className={classes.textShowOnButtonParrent}>
                <div
                  className={
                    !showDateAfterSelect
                      ? classes.textShowOnButton
                      : classes.textShowOnButtonAfterClickOnTimePeriodButton
                  }>
                  <Typography
                    className={
                      !showDateAfterSelect
                        ? classes.typographyOfButton
                        : classes.typographyOfButtonAfterSelectDate
                    }>
                    {getTranslate('From')}
                  </Typography>
                  <Typography
                    className={
                      !showDateAfterSelect
                        ? classes.typographyOfButton
                        : classes.typographyOfButtonAfterSelectDate
                    }>
                    {getTranslate('To')}
                  </Typography>
                </div>
                {showDateAfterSelect ? (
                  <div
                    className={
                      !showDateAfterSelect
                        ? classes.textShowOnButton
                        : classes.textShowOnButtonAfterSelectDateForArrivalDateAndDeparture
                    }>
                    <Typography
                      className={
                        !showDateAfterSelect
                          ? classes.typographyOfButton
                          : classes.typographyOfButtonAfterSelectDateForArrivalDateAndDeparture
                      }>
                      {getTranslate(
                        lang === 'fa'
                          ? dateObject?.jalaaliStartDate ||
                              getTranslate('Start Date')
                          : dateObject?.gregorianStartDate ||
                              getTranslate('Start Date')
                      )}
                    </Typography>
                    <span className={classes.arrowIcon}>
                      <TrendingFlatIcon />
                    </span>
                    <Typography
                      className={
                        !showDateAfterSelect
                          ? classes.typographyOfButton
                          : classes.typographyOfButtonAfterSelectDateForArrivalDateAndDeparture
                      }>
                      {getTranslate(
                        lang === 'fa'
                          ? dateObject?.jalaaliEndDate ||
                              getTranslate('End Date')
                          : dateObject?.gregorianEndDate ||
                              getTranslate('End Date')
                      )}
                    </Typography>
                  </div>
                ) : null}
              </div>
            </Button>
            <span className={classes.lineUnderButton}></span>
            {timePickerSelected ? (
              <Grow in>
                <div style={{ position: 'relative' }}>
                  <div className={classes.dateRangePicker}>
                    <DateRangePicker
                      onChange={(e: DateObject) => {
                        setdateObject(e)
                        setshowDateAfterSelect(true)
                      }}
                      type={lang === 'fa' ? 'jalaali' : 'gregorian'}
                      showDatePickerBox={timePickerSelected}
                      dateObject={dateObject}
                      onDoneClicked={() => setTimePickerSelected(false)}
                      numberOfVisibleMonths={1}
                    />
                  </div>
                </div>
              </Grow>
            ) : null}
          </div>
          <div>
            <List>
              {loading ? (
                <CircularProgress />
              ) : (
                data?.cancelPolicies.map((item) => (
                  <RatePlansAddPoliciesModalRow
                    selectedTemplate={selectedTemplate}
                    name={item.basicDetails.name}
                    onClick={() => setselectedTemplate(item.basicDetails.id)}
                    showItems={showItems}
                    id={item.basicDetails.id}
                  />
                ))
              )}
            </List>
          </div>
          <div className={classes.buttonContainer}>
            <Button variant="text" color="primary" onClick={onClose}>
              {getTranslate('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onAddPolicy}
              // add pendingForAssignment condition too
              disabled={
                !!!dateObject ||
                !!!selectedTemplate ||
                loadingForAddRatePlanPolicy
              }>
              {getTranslate('Assign')}
              {loadingForAddRatePlanPolicy && (
                <CircularProgress
                  className={classes.circularProgress}
                  size={16}
                />
              )}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default RatePlansAddPoliciesModal
